export default function extrairChavesUnicas(dados: Array<any>) {
    const todasAsChaves = dados.reduce((acc, obj) => {
        return acc.concat(Object.keys(obj));
    }, []);

    const chavesUnicas = Array.from(new Set(todasAsChaves));

    return chavesUnicas;
};